'use strict';

function FaresAdjustmentsPanelControllers($scope, featureToggleService) {
  $scope.selected = {};
  $scope.VIEW = {
    FARE_ADJUSTMENTS: 'fare-adjustments',
    SURCHARGES: 'surcharges',
    PARTNER_ADJUSTMENTS: 'partner-adjustments',
    FARE_BASIS_GROUPS: 'fare-basis-groups',
    INTERLINE_FARES_ADJUSTMENT: 'interline-fares-adjustment'
  };
  $scope.views = [{
    label: 'Surcharges',
    value: $scope.VIEW.SURCHARGES,
    disabled: false
  }, {
    label: 'Fare Basis Grps',
    value: $scope.VIEW.FARE_BASIS_GROUPS,
    disabled: false
  }, {
    label: 'Interline Fares Adjustment',
    value: $scope.VIEW.INTERLINE_FARES_ADJUSTMENT,
    disabled: false,
    hideButton: featureToggleService.isDisabled('INTERLINE_FARES_PRORATION')
  }];
  $scope.goToTab = function (tab) {
    $scope.selected.tab = tab;
  };
  $scope.isGridVisible = function (tab) {
    return $scope.selected.tab === tab;
  };
  function resetSelectedTab() {
    $scope.goToTab($scope.VIEW.SURCHARGES);
  }
  resetSelectedTab();
}
FaresAdjustmentsPanelControllers.$inject = ['$scope', 'FeatureToggleService'];
module.exports = FaresAdjustmentsPanelControllers;